import { Avatar, Box, Button, CardActionArea, CardActions, CardContent, Stack, Typography } from "@mui/material"
import { BoundImageUploadCard } from "lib/@components/image-upload-input"
import { useBoundValue } from "lib/@components/binding/use-bound-value"
import Iconify from "minimals-template/components/Iconify"

export function BoundUserPhotoURLUploader() {
    const [image, setImage] = useBoundValue("photoURL")
    return (
        <Stack>
            <BoundImageUploadCard field="photoURL" maxHeight={512}>
                <CardActionArea data-cy="user-photo-upload">
                    <CardContent
                        sx={{
                            alignItems: "center",
                            display: "flex",
                            flexDirection: "column",
                            height: image ? 300 : 350,
                            justifyContent: "center",
                        }}
                    >
                        <Box
                            sx={{
                                borderColor: "grey.50032",
                                borderRadius: "50%",
                                borderStyle: "dashed",
                                borderWidth: "1px",
                                padding: 1,
                            }}
                        >
                            <Avatar
                                sx={{
                                    width: 128,
                                    height: 128,
                                    ...(image && {
                                        backgroundImage: `linear-gradient(rgba(22, 28, 36, 0.8), rgba(22, 28, 36, 0.8)), url(${image})`,
                                    }),
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    display: "flex",
                                    flexDirection: "column",
                                }}
                            >
                                <Iconify sx={{ color: "common.white" }} icon="ic:baseline-add-a-photo" />
                                <Typography sx={{ color: "common.white" }} variant="caption">
                                    {image ? "Update photo" : "Add photo"}
                                </Typography>
                            </Avatar>
                        </Box>

                        <Typography mt={4} variant="caption">
                            Allowed *.jpeg *.jpg *.png *.gif
                        </Typography>
                    </CardContent>
                </CardActionArea>
                {image && (
                    <CardActions
                        sx={{ display: "flex", justifyContent: "center" }}
                        onClick={(event) => {
                            event.stopPropagation()
                            event.preventDefault()
                        }}
                    >
                        <Button
                            variant="text"
                            sx={{ color: "error.main" }}
                            startIcon={<Iconify icon="ic:round-delete" />}
                            onMouseDown={(event) => event.stopPropagation()}
                            onClick={(event) => {
                                event.stopPropagation()
                                event.preventDefault()
                                handleRemovePhoto()
                            }}
                        >
                            Remove photo
                        </Button>
                    </CardActions>
                )}
            </BoundImageUploadCard>
        </Stack>
    )

    function handleRemovePhoto() {
        setImage("")
    }
}
